import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**Domain */
import { ResponseRest } from 'app/interface/response-rest';
import { NotificationMail } from 'app/module-file/domain/parameter/notification/notification';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    /**propiedad url */
    private url: string = environment.url + '/Notification/';

    /*** Constructor*/
    constructor(private _httpClient: HttpClient) { }

    /** Método para listar todos */
    list(application?: string, user?: number): Observable<ResponseRest> {
        let url = `${this.url}List?application=${application}&user=${user}`;
        return this._httpClient.get<ResponseRest>(url);
    }

    /** Método para editar
    @param {NotificationMail} notification : Entidad notificación */
    edit(notification: NotificationMail) {
        let body = JSON.stringify(notification);
        let url = `${this.url}Edit`;
        return this._httpClient.post<ResponseRest>(url, body);
    }

}